import { render, staticRenderFns } from "./veStuHealthReplyShow.vue?vue&type=template&id=668d4d41&scoped=true"
import script from "./veStuHealthReplyShow.vue?vue&type=script&lang=js"
export * from "./veStuHealthReplyShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d4d41",
  null
  
)

export default component.exports